(function($) {

  $("body").on("click", "a[href]", function(e) {
    e.preventDefault();
  });

})(jQuery);
